var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUnderConstruction(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-simple--inject-56"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M159.46,450.05a190.29,190.29,0,0,0,14.63,13.85H394.73c24.33-23.13,47.36-56.33,67.54-102.22,0,0,35.74-90.49,27.42-169.81s-60.42-142-134.22-155.35S216.07,96.38,133.7,121.76-9,215.16,12.68,306.4,94.9,381.94,159.46,450.05Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plants--inject-56"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M367.23,163.35c3.21,1.4,11.06,1.22,11.06,1.22s-1.69-5.14-1.83-5.45c-1.73-3.6-7.17-9.55-11.61-9a5.29,5.29,0,0,0-4.24,6.63C361.34,159.87,364.49,162.15,367.23,163.35Z",
    style: {
      fill: "#c2c2c2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446.63,165.07c.06.05,1.42-5.21,1.47-5.55.55-4-.71-11.93-4.74-13.87a5.29,5.29,0,0,0-7.2,3.19c-1.08,3,.29,6.6,1.91,9.11C440,160.89,446.62,165.07,446.63,165.07Z",
    style: {
      fill: "#c2c2c2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M470.06,136.63c-4.45-.48-9.73,5.61-11.36,9.26-.14.32-1.77,5.5-1.69,5.5h.1c-.84,1-1.73,2-2.69,3.14-1.73,2.13-3.68,4.56-5.62,7.35a93.18,93.18,0,0,0-5.83,9.29,68.83,68.83,0,0,0-5,11.22.57.57,0,0,0,0,.14c0-1.31,0-5-.07-5.26-.52-4-3.84-11.31-8.24-12.12a5.28,5.28,0,0,0-6.1,5c-.26,3.15,2,6.3,4.25,8.29,2.51,2.24,9.47,4.41,10,4.58a95,95,0,0,0-2.95,12.15c-.42,2.39-.78,4.81-1.1,7.25,0-1.13,0-2.15-.06-2.29-.52-4-3.84-11.31-8.23-12.12a5.29,5.29,0,0,0-6.11,5c-.26,3.15,2,6.3,4.25,8.29s8.16,4,9.73,4.48l-.36,2.81c-.53,4.48-1.05,9-1.69,13.35-.22,1.54-.5,3.05-.77,4.56,0-1,0-1.85-.06-2-.51-4-3.83-11.31-8.23-12.12a5.28,5.28,0,0,0-6.1,5c-.26,3.14,2,6.29,4.25,8.28s7.58,3.79,9.44,4.39c-.33,1.54-.65,3.09-1,4.57-.28,1-.49,2-.83,3s-.64,2-.95,2.94c-.67,1.85-1.35,3.76-2.06,5.54-.47,1.25-.95,2.42-1.43,3.61.24-1.53.65-4.54.66-4.8a20.53,20.53,0,0,0-2.76-10,6.57,6.57,0,0,0-.07-1.17,5.29,5.29,0,0,0-6.47-4.49c-4.32,1.15-7.07,8.74-7.27,12.73,0,.23.14,2.8.27,4.42-.22-.94-.42-1.86-.66-2.82-.45-1.91-1-3.81-1.5-5.85l-.89-3c-.28-1-.7-2-1.05-3-.85-2.33-1.83-4.66-2.87-7,1.67-.4,7.59-1.91,10-3.74s4.87-4.78,4.85-7.94a5.29,5.29,0,0,0-5.71-5.42c-4.45.48-8.31,7.57-9.12,11.48,0,.24-.31,3.11-.42,4.69-.64-1.39-1.27-2.78-2-4.17-2-4-4.13-8-6.24-12-.65-1.22-1.28-2.44-1.92-3.67.6-.13,7.68-1.77,10.34-3.82,2.36-1.81,4.87-4.78,4.85-7.94a5.29,5.29,0,0,0-5.71-5.42c-4.45.48-8.31,7.57-9.12,11.48-.06.29-.43,4.43-.47,5.48-1.4-2.69-2.77-5.39-4-8.11a92.64,92.64,0,0,1-4.36-11.27c.28-.07,7.67-1.75,10.4-3.84,2.36-1.81,4.87-4.78,4.85-7.94a5.29,5.29,0,0,0-5.72-5.42c-4.44.48-8.3,7.57-9.11,11.48-.05.25-.34,3.4-.44,4.9l-.25,0a67.88,67.88,0,0,1-2.28-11.94c-.25-2.22-.36-4.36-.43-6.44,1.41-.17,7.84-1,10.5-2.64s5.38-4.22,5.7-7.36a5.29,5.29,0,0,0-5.09-6c-4.47,0-9.08,6.61-10.31,10.41-.07.21-.52,2.38-.82,4,0-.94-.05-1.91-.05-2.81,0-3.38.22-6.48.44-9.22.13-1.56.28-3,.44-4.28,1.29-.89,6.46-4.54,8.05-7.15s2.83-6.22,1.67-9.16a5.3,5.3,0,0,0-7.29-3c-4,2-5,10-4.36,14,.06.34,1.56,5.56,1.63,5.52l.07-.06c-.17,1.27-.34,2.62-.5,4.1-.27,2.74-.56,5.84-.64,9.24a96.08,96.08,0,0,0,.27,11,68,68,0,0,0,2,12.1s0,.09,0,.14c-.7-1.11-2.77-4.13-3-4.35-2.61-3-9.43-7.32-13.55-5.57a5.29,5.29,0,0,0-2.35,7.52c1.52,2.77,5.17,4.13,8.12,4.57,3.33.48,10.33-1.55,10.89-1.72a92.33,92.33,0,0,0,4.25,11.76c1,2.23,2,4.45,3.07,6.66-.64-.94-1.22-1.77-1.31-1.88-2.61-3-9.44-7.32-13.55-5.57a5.29,5.29,0,0,0-2.35,7.52c1.52,2.77,5.16,4.14,8.11,4.57s9-1.18,10.59-1.63c.42.85.83,1.69,1.25,2.53,2,4,4.07,8.07,6,12.07.66,1.41,1.26,2.83,1.87,4.24-.57-.83-1.06-1.53-1.14-1.62-2.61-3-9.44-7.32-13.55-5.57a5.28,5.28,0,0,0-2.35,7.51c1.52,2.77,5.16,4.14,8.11,4.57s8.42-1,10.31-1.55c.57,1.47,1.16,2.94,1.65,4.38.32,1,.69,1.94.95,2.95s.55,2,.83,3c.46,1.91.94,3.88,1.34,5.75.29,1.31.54,2.55.8,3.81-.65-1.42-2-4.16-2.1-4.37-2.13-3.38-8.22-8.67-12.56-7.56a5.28,5.28,0,0,0-3.45,7.07c1.08,3,4.47,4.87,7.32,5.75,3.15,1,10.1.08,11,0,.41,2.08.8,4.11,1.13,6,.58,3.26,1,6.26,1.42,8.93h2.89c-.46-2.8-1-6-1.7-9.42-.42-2.11-.9-4.35-1.42-6.66a60.11,60.11,0,0,0,6.11-2.87c2.29,2.48,8.16,5.38,8.92,5.75-.8,2-1.6,3.86-2.38,5.64-1.2,2.76-2.35,5.29-3.42,7.56h3.09c.89-2,1.82-4.18,2.77-6.53.82-2,1.66-4.13,2.5-6.34.84.18,7.72,1.58,10.93.85,2.91-.66,6.43-2.3,7.73-5.18a5.28,5.28,0,0,0-2.92-7.31c-4.24-1.43-10.71,3.39-13.08,6.6-.14.19-1.43,2.42-2.22,3.84.34-.91.68-1.78,1-2.72.68-1.84,1.3-3.7,2-5.7.29-1,.59-2,.88-3s.53-2.06.8-3.1c.58-2.42,1-4.9,1.46-7.41,1.61.59,7.38,2.6,10.37,2.39s6.71-1.31,8.43-4a5.29,5.29,0,0,0-1.78-7.68c-4-2-11.1,1.73-13.93,4.55-.17.18-2,2.43-2.94,3.68.23-1.51.48-3,.67-4.55.55-4.44,1-8.94,1.41-13.43.13-1.38.28-2.75.42-4.12.58.21,7.38,2.75,10.73,2.51,3-.21,6.71-1.3,8.43-4a5.28,5.28,0,0,0-1.78-7.67c-4-2.05-11.1,1.73-13.93,4.55-.21.21-2.8,3.45-3.42,4.31.32-3,.66-6,1.13-9a93.18,93.18,0,0,1,2.57-11.81c.27.1,7.36,2.78,10.79,2.53,3-.2,6.71-1.3,8.43-3.94a5.29,5.29,0,0,0-1.78-7.68c-4-2-11.1,1.73-13.93,4.55-.18.18-2.16,2.65-3.07,3.85l-.23-.12a68.9,68.9,0,0,1,4.69-11.22c1-2,2.1-3.83,3.2-5.6,1.27.63,7.1,3.46,10.21,3.59s6.81-.56,8.81-3a5.29,5.29,0,0,0-.92-7.82c-3.73-2.47-11.22.5-14.35,3-.17.13-1.74,1.7-2.87,2.86.51-.79,1-1.62,1.51-2.37,1.87-2.82,3.76-5.28,5.45-7.45,1-1.23,1.87-2.32,2.73-3.33,1.57,0,7.89-.22,10.66-1.51s5.79-3.64,6.44-6.73A5.29,5.29,0,0,0,470.06,136.63Z",
    style: {
      fill: "#c2c2c2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.26,235.89c3.21,1.4,11.06,1.22,11.06,1.22s-1.69-5.13-1.83-5.45c-1.73-3.6-7.17-9.55-11.61-8.95a5.29,5.29,0,0,0-4.24,6.63C17.37,232.41,20.52,234.69,23.26,235.89Z",
    style: {
      fill: "#c2c2c2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.66,237.62c.06,0,1.42-5.22,1.47-5.56.55-4-.71-11.92-4.74-13.87a5.29,5.29,0,0,0-7.2,3.19c-1.08,3,.29,6.61,1.91,9.11C96,233.43,102.65,237.61,102.66,237.62Z",
    style: {
      fill: "#c2c2c2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.09,209.17c-4.45-.48-9.73,5.61-11.36,9.26-.14.32-1.77,5.5-1.69,5.5h.1c-.84.95-1.73,2-2.69,3.14-1.73,2.14-3.68,4.57-5.62,7.35A95,95,0,0,0,99,243.71a68.83,68.83,0,0,0-5,11.22.57.57,0,0,0,0,.14c0-1.31,0-5-.07-5.26-.52-4-3.84-11.31-8.24-12.12a5.29,5.29,0,0,0-6.1,5c-.26,3.14,2,6.29,4.25,8.28,2.51,2.24,9.47,4.41,10,4.58a95.36,95.36,0,0,0-2.95,12.15c-.42,2.39-.78,4.82-1.1,7.25,0-1.13,0-2.15-.06-2.29-.52-4-3.84-11.31-8.23-12.12a5.3,5.3,0,0,0-6.11,5c-.26,3.14,2,6.29,4.25,8.28s8.16,4,9.73,4.49l-.36,2.8c-.53,4.49-1,9-1.69,13.35-.22,1.54-.5,3.05-.77,4.57,0-1,0-1.86-.06-2-.51-4-3.83-11.31-8.23-12.12a5.29,5.29,0,0,0-6.1,5c-.26,3.14,2,6.29,4.25,8.28s7.58,3.79,9.44,4.39c-.33,1.55-.65,3.09-1,4.57-.28,1-.49,2-.83,3s-.64,2-.95,2.94c-.67,1.85-1.35,3.76-2.06,5.54-.47,1.25-1,2.43-1.43,3.61.24-1.53.65-4.54.66-4.8a20.5,20.5,0,0,0-2.76-10,6.62,6.62,0,0,0-.07-1.18,5.3,5.3,0,0,0-6.47-4.49c-4.32,1.16-7.07,8.74-7.27,12.73,0,.23.14,2.8.27,4.42-.22-.94-.42-1.86-.66-2.82-.45-1.91-1-3.81-1.5-5.85l-.89-2.95c-.28-1-.7-2-1-3-.85-2.33-1.83-4.66-2.87-7,1.67-.4,7.59-1.91,10-3.74s4.87-4.78,4.85-7.94a5.29,5.29,0,0,0-5.71-5.42c-4.45.49-8.31,7.57-9.12,11.48,0,.24-.31,3.11-.42,4.7-.64-1.4-1.27-2.79-1.95-4.17-2-4-4.13-8-6.24-12-.65-1.23-1.28-2.45-1.92-3.67.6-.14,7.68-1.78,10.34-3.82,2.36-1.82,4.87-4.79,4.85-7.95a5.29,5.29,0,0,0-5.71-5.42c-4.45.49-8.31,7.57-9.12,11.48-.06.3-.43,4.43-.47,5.48-1.4-2.69-2.77-5.39-4-8.11a92,92,0,0,1-4.36-11.27c.28-.06,7.67-1.74,10.4-3.84,2.36-1.81,4.87-4.78,4.85-7.94a5.29,5.29,0,0,0-5.72-5.42c-4.44.48-8.3,7.57-9.11,11.48,0,.26-.34,3.41-.44,4.91l-.25,0a67.7,67.7,0,0,1-2.28-11.94c-.25-2.22-.36-4.36-.43-6.44,1.41-.17,7.84-1,10.5-2.64s5.38-4.22,5.7-7.36a5.29,5.29,0,0,0-5.09-6c-4.47,0-9.08,6.61-10.31,10.41-.07.21-.52,2.38-.82,4,0-.94,0-1.91,0-2.81,0-3.38.22-6.48.44-9.22.13-1.56.28-3,.44-4.27,1.29-.89,6.46-4.55,8-7.16s2.83-6.22,1.67-9.15a5.3,5.3,0,0,0-7.29-3c-4,2.06-5,10-4.36,14,.06.34,1.56,5.57,1.63,5.52l.07-.05c-.17,1.26-.34,2.61-.5,4.09-.27,2.75-.56,5.85-.64,9.24a96.08,96.08,0,0,0,.27,11,68,68,0,0,0,2,12.1c0,.05,0,.09,0,.14-.7-1.11-2.77-4.13-3-4.35-2.61-3-9.43-7.31-13.55-5.57a5.29,5.29,0,0,0-2.35,7.52c1.52,2.77,5.17,4.14,8.12,4.57,3.33.48,10.33-1.55,10.89-1.71a92.76,92.76,0,0,0,4.25,11.75c1,2.23,2,4.45,3.07,6.66-.64-.93-1.22-1.77-1.31-1.87-2.61-3-9.44-7.32-13.55-5.58A5.29,5.29,0,0,0,27,275.4c1.52,2.77,5.16,4.14,8.11,4.57s9-1.18,10.59-1.63l1.25,2.54c2,4,4.07,8.06,6,12.06.66,1.42,1.26,2.83,1.87,4.24-.57-.83-1.06-1.52-1.14-1.62-2.61-3-9.44-7.32-13.55-5.57a5.29,5.29,0,0,0-2.35,7.52c1.52,2.76,5.16,4.13,8.11,4.56s8.42-1,10.31-1.54c.57,1.46,1.16,2.93,1.65,4.38.32,1,.69,1.93.95,2.94s.55,2,.83,3c.46,1.91.94,3.88,1.34,5.76.29,1.3.54,2.54.8,3.8-.65-1.41-2-4.15-2.1-4.37-2.13-3.38-8.22-8.66-12.56-7.56a5.29,5.29,0,0,0-3.45,7.08c1.08,3,4.47,4.87,7.32,5.74,3.15,1,10.1.08,11,0,.41,2.08.8,4.11,1.13,6,.58,3.26,1,6.26,1.42,8.93h2.89c-.46-2.8-1-6-1.7-9.41-.42-2.11-.9-4.36-1.42-6.67a55.77,55.77,0,0,0,6.11-2.87c2.29,2.48,8.16,5.38,8.92,5.75-.8,2-1.6,3.86-2.38,5.64-1.2,2.77-2.35,5.29-3.42,7.56h3.09c.89-2,1.82-4.18,2.77-6.53.82-2,1.66-4.13,2.5-6.34.84.18,7.72,1.58,10.93.85,2.91-.65,6.43-2.3,7.73-5.18a5.28,5.28,0,0,0-2.92-7.31c-4.24-1.42-10.71,3.39-13.08,6.6-.14.19-1.43,2.42-2.22,3.84.34-.91.68-1.78,1-2.72.68-1.84,1.3-3.7,2-5.7.29-1,.59-2,.88-3s.53-2.06.8-3.1c.58-2.42,1-4.9,1.46-7.41,1.61.59,7.38,2.6,10.37,2.39s6.71-1.3,8.43-3.95a5.28,5.28,0,0,0-1.78-7.67c-4-2.05-11.1,1.73-13.93,4.54-.17.18-2,2.43-2.94,3.68.23-1.51.48-3,.67-4.55.55-4.43,1-8.94,1.41-13.43.13-1.38.28-2.75.42-4.12.58.22,7.38,2.75,10.73,2.51,3-.2,6.71-1.3,8.43-3.94a5.29,5.29,0,0,0-1.78-7.68c-4-2.05-11.1,1.73-13.93,4.55-.21.21-2.8,3.45-3.42,4.31.32-3,.66-6,1.13-9a93.56,93.56,0,0,1,2.57-11.81c.27.1,7.36,2.78,10.79,2.54,3-.21,6.71-1.31,8.43-4a5.28,5.28,0,0,0-1.78-7.67c-4-2.05-11.1,1.72-13.93,4.54-.18.19-2.16,2.65-3.07,3.85l-.23-.12a68.42,68.42,0,0,1,4.69-11.21c1-2,2.1-3.84,3.2-5.61,1.27.63,7.1,3.47,10.21,3.59s6.81-.56,8.81-3a5.29,5.29,0,0,0-.92-7.82c-3.73-2.47-11.22.5-14.35,3-.17.14-1.74,1.7-2.87,2.86.51-.79,1-1.62,1.51-2.37,1.87-2.82,3.76-5.28,5.45-7.45,1-1.22,1.87-2.31,2.73-3.32,1.57,0,7.89-.22,10.66-1.52s5.79-3.64,6.44-6.72A5.29,5.29,0,0,0,126.09,209.17Z",
    style: {
      fill: "#c2c2c2"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Device--inject-56"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M66.26,192.47h375a10.46,10.46,0,0,1,10.46,10.46v246.5a0,0,0,0,1,0,0H55.81a0,0,0,0,1,0,0V202.92A10.46,10.46,0,0,1,66.26,192.47Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 71.87,
    y: 212.54,
    width: 363.76,
    height: 205.57,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 118.62,
    y: 437.06,
    width: 272.07,
    height: 13.4,
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 118.62,
    y: 443.51,
    width: 272.07,
    height: 6.95,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.79,458.4s4.47,5.47,17.88,9.93h426s9.93-2.48,14.4-9.43Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 22.89,
    y: 448.62,
    width: 460.11,
    height: 10.44,
    rx: 1.89,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.14,200.24a3.48,3.48,0,1,0-3.48,3.47A3.48,3.48,0,0,0,257.14,200.24Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 10,
    y1: 468.33,
    x2: 497,
    y2: 468.33,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Sign--inject-56"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M285.22,251.12a10.43,10.43,0,0,0,2.87-9.38l-6.55,6.54a2,2,0,0,1-2.8,0l-5.44-5.44a2,2,0,0,1,0-2.8l6.54-6.55a10.45,10.45,0,0,0-11.73,14L251.21,264l-1.63-1.63,2.66-2.66a.74.74,0,0,0,0-1l-2.06-2.05a.72.72,0,0,0-1,0l-1,1-2.23-2.22.86-.86a1,1,0,0,0,0-1.37l-18.44-18.44a4.73,4.73,0,0,0-6.69,0l-1.88,1.88a4.73,4.73,0,0,0,0,6.69l18.44,18.44a1,1,0,0,0,1.37,0l.85-.86,2.23,2.23-1,1a.72.72,0,0,0,0,1l2,2.06a.74.74,0,0,0,1,0l2.66-2.66,1.6,1.6-14,13.67a10.44,10.44,0,0,0-14,11.73l6.55-6.54a2,2,0,0,1,2.8,0l5.44,5.44a2,2,0,0,1,0,2.8l-6.54,6.55a10.45,10.45,0,0,0,11.73-14l14-13.66,19.1,19.1a3.92,3.92,0,0,0,.88,4.18l4.61,4.61,5.53-5.53-4.61-4.61a3.92,3.92,0,0,0-4.18-.88L257.16,270l16.89-16.49A10.45,10.45,0,0,0,285.22,251.12Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.33,326.59c0,2,.79,3.17,2.58,3.17s2.54-1.19,2.54-3.17V309.78h2.3v16.69c0,3.33-1.54,5.56-4.94,5.56s-4.9-2.23-4.9-5.56V309.78h2.42Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.33,331.78h-2.2v-22h3.11l5.09,15.9v-15.9h2.17v22H244L238.33,314Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.17,309.78c3.42,0,5,2.08,5,5.47v11.09c0,3.36-1.57,5.44-5,5.44H249v-22Zm0,19.76c1.76,0,2.61-1.09,2.61-3.11V315.12c0-2-.85-3.11-2.64-3.11h-2.64v17.53Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.28,319.52v2.2H263.9v7.82h6.6v2.24h-9.05v-22h9.05V312h-6.6v7.51Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.66,309.78c3.46,0,4.9,1.76,4.9,5v1.79c0,2.42-.85,3.93-2.73,4.53,2,.59,2.76,2.23,2.76,4.58v3.43a5.64,5.64,0,0,0,.44,2.64h-2.48a5.83,5.83,0,0,1-.41-2.68v-3.45c0-2.48-1.16-3.27-3.2-3.27h-1.73v9.4h-2.45v-22ZM277,320.15c2,0,3.11-.63,3.11-3V315c0-2-.72-3-2.54-3h-2.39v8.14Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.28,360v2H193v-2.11c0-2-.79-3.17-2.58-3.17s-2.58,1.19-2.58,3.17V371.5c0,2,.82,3.17,2.58,3.17s2.58-1.19,2.58-3.17v-2.86h2.32v2.73c0,3.33-1.57,5.53-5,5.53s-4.93-2.2-4.93-5.53V360c0-3.33,1.57-5.53,4.93-5.53S195.28,356.67,195.28,360Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.32,360c0-3.36,1.67-5.53,5-5.53s5.06,2.17,5.06,5.53v11.37c0,3.33-1.67,5.53-5.06,5.53s-5-2.2-5-5.53Zm2.42,11.5c0,2,.85,3.17,2.61,3.17s2.61-1.16,2.61-3.17V359.87c0-2-.82-3.17-2.61-3.17s-2.61,1.19-2.61,3.17Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.9,376.68h-2.2v-22h3.11l5.09,15.9v-15.9h2.17v22h-2.55L211.9,358.9Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.1,360v.59h-2.33v-.72c0-2-.75-3.14-2.51-3.14s-2.51,1.16-2.51,3.11c0,4.93,7.38,5.4,7.38,11.59,0,3.33-1.6,5.5-5,5.5s-4.93-2.17-4.93-5.5v-1.25h2.3v1.38c0,2,.81,3.14,2.57,3.14s2.58-1.16,2.58-3.14c0-4.9-7.35-5.37-7.35-11.56,0-3.4,1.57-5.5,4.87-5.5S232.1,356.64,232.1,360Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.47,376.68V356.92h-4.06v-2.23H244v2.23h-4.05v19.76Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.57,354.69c3.45,0,4.9,1.76,4.9,5v1.8c0,2.41-.85,3.92-2.73,4.52,2,.6,2.76,2.23,2.76,4.59V374a5.47,5.47,0,0,0,.44,2.64h-2.48a5.65,5.65,0,0,1-.41-2.67v-3.46c0-2.48-1.16-3.26-3.21-3.26h-1.72v9.39h-2.45v-22Zm-.63,10.37c1.95,0,3.11-.63,3.11-3v-2.11c0-2-.72-3-2.55-3h-2.38v8.14Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.37,371.5c0,2,.78,3.17,2.57,3.17s2.55-1.19,2.55-3.17V354.69h2.29v16.68c0,3.33-1.54,5.56-4.93,5.56s-4.9-2.23-4.9-5.56V354.69h2.42Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.91,360v2h-2.33v-2.11c0-2-.78-3.17-2.57-3.17s-2.58,1.19-2.58,3.17V371.5c0,2,.82,3.17,2.58,3.17s2.57-1.19,2.57-3.17v-2.86h2.33v2.73c0,3.33-1.57,5.53-5,5.53s-4.93-2.2-4.93-5.53V360c0-3.33,1.57-5.53,4.93-5.53S279.91,356.67,279.91,360Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.34,376.68V356.92h-4v-2.23h10.55v2.23h-4v19.76Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296,354.69v22h-2.45v-22Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.31,360c0-3.36,1.67-5.53,5-5.53s5.06,2.17,5.06,5.53v11.37c0,3.33-1.67,5.53-5.06,5.53s-5-2.2-5-5.53Zm2.42,11.5c0,2,.85,3.17,2.61,3.17s2.61-1.16,2.61-3.17V359.87c0-2-.82-3.17-2.61-3.17s-2.61,1.19-2.61,3.17Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.89,376.68h-2.2v-22h3.11l5.09,15.9v-15.9h2.17v22h-2.55l-5.62-17.78Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 171.72,
    y: 337.62,
    width: 159.52,
    height: 9.51,
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "234.11 337.62 223.49 337.62 218.04 347.12 228.66 347.12 234.11 337.62",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "331.24 347.12 331.24 338.54 326.32 347.12 331.24 347.12",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "255.76 337.62 245.14 337.62 239.7 347.12 250.32 347.12 255.76 337.62",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "212.45 337.62 201.83 337.62 196.38 347.12 207.01 347.12 212.45 337.62",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "174.73 347.12 185.35 347.12 190.8 337.62 180.17 337.62 174.73 347.12",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "320.73 337.62 310.11 337.62 304.67 347.12 315.29 347.12 320.73 337.62",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "277.42 337.62 266.8 337.62 261.35 347.12 271.98 347.12 277.42 337.62",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "299.08 337.62 288.45 337.62 283.01 347.12 293.63 347.12 299.08 337.62",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Cone--inject-56"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M99.24,357.75,71.92,462.12h60.93L105.53,357.75A3.23,3.23,0,0,0,99.24,357.75Z",
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "71.92 462.12 121.56 462.12 96.74 367.29 71.92 462.12",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 59,
    y: 459.83,
    width: 84,
    height: 8.51,
    rx: 4,
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 59,
    y: 459.83,
    width: 57.99,
    height: 8.51,
    rx: 4,
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "82.82 420.49 121.95 420.49 117.22 402.41 87.55 402.41 82.82 420.49",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "82.82 420.49 110.67 420.49 105.94 402.41 87.55 402.41 82.82 420.49",
    style: {
      fill: "#bababa",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Lamp--inject-56"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 253.88,
    cy: 132.67,
    r: 8.77,
    transform: "translate(-19.45 218.38) rotate(-45)",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 254.13,
    y1: 61.84,
    x2: 254.13,
    y2: 20.87,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 254.13,
    y1: 88.9,
    x2: 254.13,
    y2: 61.84,
    style: {
      fill: "none",
      stroke: "gray",
      strokeMiterlimit: 10,
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "240.54 88.9 213.47 135.8 294.23 135.8 267.15 88.9 240.54 88.9",
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: "0.9727319999999999px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "243.26 88.9 221.71 135.8 285.99 135.8 264.44 88.9 243.26 88.9",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shade--inject-56"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M179.69,192.47H66.26a10.45,10.45,0,0,0-10.45,10.45V401Z",
    style: {
      fill: "gray",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.8,192.47H441.23a10.45,10.45,0,0,1,10.45,10.45V401.61Z",
    style: {
      fill: "gray",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 179.69,
    y1: 192.47,
    x2: 55.81,
    y2: 401.03,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 327.8,
    y1: 192.47,
    x2: 451.68,
    y2: 401.61,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "71.87 374.31 71.87 212.54 167.31 212.54",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "339.91 212.54 435.62 212.54 435.62 375.13",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "327.8 192.47 294.23 135.8 213.47 135.8 179.69 192.47",
    style: {
      fill: "#fff",
      fillOpacity: 0.3,
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnderConstruction);
export default __webpack_public_path__ + "static/media/under-construction.007a2ecf0a3aff4c503870030a942c42.svg";
export { ForwardRef as ReactComponent };